__turbopack_context__.v({
  "deck": "SeeInAction-module-scss-module__VfVA2G__deck",
  "heading": "SeeInAction-module-scss-module__VfVA2G__heading",
  "section": "SeeInAction-module-scss-module__VfVA2G__section",
});
